import { render } from "./Table.vue?vue&type=template&id=e54ccd7e&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=e54ccd7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dyamd\\OneDrive\\Documents\\PROYECTOS\\ceramicas\\mi-stock-ceramicas-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54ccd7e"]])

export default __exports__